<script>
export default {
  name: 'LegacyLoadingPlaceholder',
  props: {
    loading: { type: Boolean, default: true },
    subheader: { type: Boolean, default: false },
    stats: { type: Boolean, default: false },
    charts: { type: Boolean, default: false },
    table: { type: Boolean, default: false },
  },
}
</script>

<template>
  <div v-if="loading" class="space-y-4 animate-pulse">
    <div v-if="subheader" class="h-6 w-1/3 rounded bg-muted" />
    <div v-if="stats" class="grid grid-cols-2 md:grid-cols-4 gap-3">
      <div v-for="i in 4" :key="`s${i}`" class="h-20 rounded-xl bg-muted" />
    </div>
    <div v-if="charts" class="h-48 rounded-xl bg-muted" />
    <div v-if="table" class="space-y-2">
      <div v-for="i in 5" :key="`t${i}`" class="h-10 rounded bg-muted" />
    </div>
  </div>
</template>
